import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { ButtonModule } from '@coreui/angular-pro';
import { NgIf } from '@angular/common';

export interface PdfPreviewData {
  pdfBlob: Blob;
  fileName: string;
}

@Component({
  selector: 'app-pdf-preview-modal',
  standalone: true,
  imports: [NgIf, MatDialogModule, ButtonModule],
  templateUrl: './pdf-preview-modal.component.html',
  styleUrls: ['./pdf-preview-modal.component.scss']
})
export class PdfPreviewModalComponent implements OnInit, OnDestroy {
  pdfUrl: SafeResourceUrl | null = null;
  downloadUrl: string = '';
  private originalTitle: string = '';

  constructor(
    public dialogRef: MatDialogRef<PdfPreviewModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PdfPreviewData,
    private sanitizer: DomSanitizer,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.originalTitle = this.titleService.getTitle();
    this.titleService.setTitle(this.data.fileName);

    const file = new File([this.data.pdfBlob], `${this.data.fileName}.pdf`, { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(file);
    // Agregamos parámetros de visualización para intentar ocultar la barra de herramientas nativa
    // y forzar el uso de nuestro botón de descarga, que sí respeta el nombre del archivo.
    const namedBlobUrl = `${blobUrl}#toolbar=1&scrollbar=0&view=Fit&filename=${encodeURIComponent(this.data.fileName + '.pdf')}`;
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(namedBlobUrl);
    this.downloadUrl = blobUrl;
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(this.originalTitle);
  }

  downloadPdf(): void {
    const link = document.createElement('a');
    link.href = this.downloadUrl;
    link.download = `${this.data.fileName}.pdf`;
    link.click();
  }

  close(): void {
    this.dialogRef.close();
  }
}
